<!--
 * @Description:审核记录
 * @Author: cxh
 * @Date: 2022-05-24 15:19:34
 * @LastEditTime: 2023-03-14 09:49:37
 * @LastEditors: cxh
-->
<template>
  <a-form scrollToFirstError>
    <dc-layout-card :title="props.title" :span="24">
      <a-col>
        <cos-table
          tableId="DcCosOFbuApplyRecord"
          :needPage="false"
          serial
          :columns="columns"
          @fetch="fetch"
          ref="table"
        >
          <template #bodyCell="{ column, record }">
            <template v-if="column.dataIndex === 'checkNode'">
              <p v-if="record.checkNode === '申请'">{{ t('clue.approvalPersonNode') }}</p>
              <p v-else>{{ t('clue.approvalNode') }}</p>
            </template>
            <template v-if="column.dataIndex === 'content'">
              <p v-if="record.checkNode === '申请'">{{ `${t('clue.approvalCause')}${record.applyReason}` }}</p>
              <p v-else>{{ state[record.auditStatus] }} {{ record.opinion ? `【${record.opinion}】` : '' }}</p>
            </template>
          </template>
        </cos-table>
      </a-col>
    </dc-layout-card>
  </a-form>
</template>
<script setup lang="ts">
import { computed } from 'vue'
import { cluerApplyecord } from '@/api/overseasSales/clueManage'
import { useRoute } from 'vue-router'
import { useI18n } from 'vue-i18n'
const { t } = useI18n()
const route = useRoute()
const props = defineProps({
  returnName: {
    type: String
  },
  title: String
})
const state = computed(() => {
  return {
    1: t('operate.sukg7w'),
    2: t('operate.cfq4cr'),
    3: t('operate.fvmvfe')
  }
})
const fetch = (params: object, callBack: (res: any) => void) => {
  if (route.query.recordId) {
    cluerApplyecord({
      recordId: route.query.recordId
    }).then((res) => {
      // 处理数据
      const result = []
      result.push({
        checkTime: res.data.applyTime,
        checkUser: res.data.createByName,
        applyReason: res.data.applyReason,
        checkNode: '申请',
        ...res.data
      })
      // 审批
      result.push({
        checkTime: res.data.auditTime,
        checkUser: res.data.auditorName,
        checkNode: '审批',
        ...res.data
      })
      // 拼申请人
      callBack({
        data: result
      })
    })
  }
}
const columns = computed(() => [
  {
    title: t('common.operatorDate'),
    dataIndex: 'checkTime'
  },
  {
    title: t('common.operator'),
    dataIndex: 'checkUser'
  },
  {
    title: t('clue.panelPoint '),
    dataIndex: 'checkNode'
  },
  {
    title: t('clue.approvalContent'),
    dataIndex: 'content'
  }
])
</script>
<script lang="ts">
export default {
  name: 'TabsOperationLog'
}
</script>
<style lang="scss" scoped></style>
